export function emptyFunc() {}

export function replaceUnicode(sourceStr)
{
	// UniCode编码表及部分不可见字符过滤方案
	// https://www.cnblogs.com/fan-yuan/p/8176886.html
	let reg = "[" +
		"\u0000-\u001F" +//：C0控制符及基本拉丁文 (C0 Control and Basic Latin) 
		"\u007F-\u00A0" +//：特殊 (Specials);
		"]";
	let regExp = new RegExp(reg);
	// let matcher = pattern.matcher(sourceStr);
	return sourceStr.replace(regExp,'');
}

export const getStyle = (obj,attr)=>{
    if (obj.currentStyle) {
        return obj.currentStyle[attr];
    }
    else {
        let value = 0;
        try{
            value = document.defaultView.getComputedStyle(obj, null)[attr];
        }catch (e) {}
        return parseInt(value);
    }
}